<div class="ccl-input-wrapper">
  @if (label) {
    <label [for]="inputId" [id]="labelId" class="ccl-input__label">
      {{ label }}
      @if (required) {
        <span class="ccl-input__required" aria-label="required">*</span>
      }
    </label>
  }

  <input
    [id]="inputId"
    class="ccl-input"
    [attr.type]="type"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [readonly]="readonly"
    [value]="value"
    [attr.aria-label]="ariaLabel"
    [attr.aria-describedby]="describedBy"
    [attr.aria-invalid]="error"
    [attr.aria-required]="required"
    [attr.minlength]="minLength"
    [attr.maxlength]="maxLength"
    [attr.min]="min"
    [attr.max]="max"
    (input)="onInput($event)"
  />

  @if (helperText) {
    <span [id]="hintId" class="ccl-input__helper">
      {{ helperText }}
    </span>
  }

  @if (error && errorMessage) {
    <span [id]="errorId" class="ccl-input__error" role="alert">
      {{ errorMessage }}
    </span>
  }
</div>
